const classRoomApi = {
  GETROOMLISTALL: 'CSVPA-China/api/classRoom/getListAll' //所有教室
}

export default classRoomApi
